// eslint-disable-next-line no-shadow
export var RECAPTCHA_ACTION;
(function (RECAPTCHA_ACTION) {
    RECAPTCHA_ACTION["B2B_UPDATE_COMPANY_DETAILS"] = "B2B_Update_Company_Details";
    RECAPTCHA_ACTION["B2B_UPDATE_PERSONAL_DETAILS"] = "B2B_Update_Personal_Details";
    RECAPTCHA_ACTION["B2C_UPDATE_PERSONAL_DETAILS"] = "B2C_Update_Personal_Details";
    RECAPTCHA_ACTION["B2C_CLOSE_ACCOUNT"] = "B2C_Close_Account";
})(RECAPTCHA_ACTION || (RECAPTCHA_ACTION = {}));
